import { FormattedMessage } from 'react-intl';

import { SecondaryLink, SvgMap } from '@tmapy/style-guide';

import { docEditButtonsMsg } from './docEditMessages';
import { Svg3d } from './Svg3d';

import './MapReviewButtons.scss';

type MapReviewButtonsProps = {
  reviewUrl: string | null;
  review3dUrl: string | null;
};

/**
 * Sdružené tlačítko pro zobrazení mapy. Když jsou nakonfigurované obě varianty
 * (2D i 3D), vykreslí se jako orámovaný control s neutrálním popiskem a zelenými
 * volbami 2D / 3D. Když je zapnutá jen jedna, sbalí se na jedno plné tlačítko.
 */
export function MapReviewButtons({ reviewUrl, review3dUrl }: MapReviewButtonsProps) {
  if (reviewUrl && review3dUrl) {
    return (
      <div className='dmx-mapReview'>
        <span className='dmx-mapReview--label'>
          <FormattedMessage {...docEditButtonsMsg.docBtnMapReviewShort} />
        </span>
        <SecondaryLink href={reviewUrl} target='_blank' icon={{ element: <SvgMap /> }}>
          2D
        </SecondaryLink>
        <SecondaryLink href={review3dUrl} target='_blank' icon={{ element: <Svg3d /> }}>
          3D
        </SecondaryLink>
      </div>
    );
  }

  if (reviewUrl) {
    return (
      <SecondaryLink href={reviewUrl} target='_blank' icon={{ element: <SvgMap /> }}>
        <FormattedMessage {...docEditButtonsMsg.docBtnMapReview} />
      </SecondaryLink>
    );
  }

  if (review3dUrl) {
    return (
      <SecondaryLink href={review3dUrl} target='_blank' icon={{ element: <Svg3d /> }}>
        <FormattedMessage {...docEditButtonsMsg.docBtnMapReview3d} />
      </SecondaryLink>
    );
  }

  return null;
}
